import { SEARCH } from '../constants';
export function getAllResults(search, query = '', page = 1, page_size = 32) {
    let url = `/tablet/products/search/${search}/all/`;

    if (query) {
        if (query.startsWith('?')) {
            url += query;
        } else if (query.startsWith('&')) {
            url += '?' + query.substring(1);
        } else {
            url += '?' + query;
        }
    }

    const separator = url.includes('?') ? '&' : '?';
    url += `${separator}page=${page}&page_size=${page_size}`;

    return {
        type: SEARCH.SEARCH_ALL,
        payload: {
            client: 'default',
            request: {
                url,
                method: 'GET',
            },
        },
    };
}




export function getSearchResults(search, cancelToken) {
    return {
        type: SEARCH.SEARCH,
        payload: {
            client: 'default',
            request: {
                url: `/tablet/products/search/${search}/`,
                method: "GET",
                cancelToken: cancelToken.token
            }
        }
    };
}